module.exports = __webpack_public_path__ + "d363b45e83ed5cca7b93bce81e4fe8a2.png";